import React, { Component } from 'react';
import pageData from '../data/pages/about.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/aboutUs.js";
import { getAssetUrl } from '../helper/assets';

class AboutUs extends Component {
    render() {
        const Datas = pageData.aboutUs;
        return (
            <Styles>
                {/* About Us */}
                <section className="about-us" style={{ paddingBottom: '30px' }}>
                    <Container>
                        <Row className="align-items-center mb-4">
                            <Col lg="5" md="12" className="mb-4 mb-lg-0">
                                <div className="about-image">
                                    <img 
                                        src={getAssetUrl("globalAbroad/why_us.png")} 
                                        className="main-img" 
                                        alt="Global Abroad Student Consultancy" 
                                        style={{ width: '100%', borderRadius: '10px', boxShadow: '0 10px 30px rgba(0,0,0,0.08)' }} 
                                    />
                                    <img src={getAssetUrl("pattern.png")} className="pattern-img" alt="" />
                                </div>
                            </Col>
                            <Col lg="7" md="12">
                                <div className="about-content">
                                    {Datas.headerTag && (
                                        <h6 className="sub-title" style={{ color: '#0056b3', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px', fontSize: '14px' }}>
                                            {Datas.headerTag}
                                        </h6>
                                    )}
                                    <h2 className="about-title" style={{ fontWeight: '700', color: '#1a2b49', marginBottom: '20px', fontSize: '32px' }}>
                                        {Datas.title}
                                    </h2>
                                    {Datas.paragraphs && Datas.paragraphs.map((p, idx) => (
                                        <p key={idx} className="about-para" style={{ fontSize: '15px', color: '#4a5568', lineHeight: '1.7', marginBottom: '14px' }}>
                                            {p}
                                        </p>
                                    ))}
                                </div>
                            </Col>
                        </Row>

                        {Datas.subTitle && (
                            <Row className="mt-3">
                                <Col lg="12">
                                    <div className="dream-start-box" style={{ background: '#f8fafc', padding: '35px 40px', borderRadius: '12px', borderLeft: '5px solid #0056b3', boxShadow: '0 4px 15px rgba(0,0,0,0.03)' }}>
                                        <h3 style={{ fontWeight: '700', color: '#1a2b49', marginBottom: '16px', fontSize: '24px' }}>
                                            {Datas.subTitle}
                                        </h3>
                                        {Datas.subParagraphs && Datas.subParagraphs.map((sp, idx) => (
                                            <p key={idx} style={{ fontSize: '15px', color: '#4a5568', lineHeight: '1.7', marginBottom: idx === Datas.subParagraphs.length - 1 ? '0' : '12px' }}>
                                                {sp}
                                            </p>
                                        ))}
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </Container>
                </section>
            </Styles>
        )
    }
}

export default AboutUs;
